import { isSP, qs } from '../common/utils'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default class Sec5_AboutUs {
  constructor() {
    
    this.el = qs('.p-top-aboutus')
    if(!this.el) return
    
    this.slideSetting()
    this.bgSetting()
  }
  
  slideSetting()
  {
    if(isSP()) return
    
    const list = qs('.p-top-aboutus__list')
    const item_wrapper = qs('.p-top-aboutus .list-item-wrapper')
    const progress = qs('.p-top-aboutus__progress >div')

    const xTw = gsap.fromTo(list,
    {
      x: 0,
    },
    {
      x    : () => list.clientWidth - item_wrapper.scrollWidth - 70 / 1400 * window.innerWidth,
      ease : 'sine.inOut',
    })

    ScrollTrigger.create({
      trigger    : this.el,
      endTrigger : this.el,
      start : 'center 33%',
      end   : () => '+=' + window.innerHeight * 1.5,
      scrub      : true,
      pin        : true,
      pinSpacing : true,
      invalidateOnRefresh: true,
      animation  : xTw,
      onUpdate: (self) => {
        progress.style.transform = `scaleX(${self.progress})`
      }
    })

    this.animation = xTw
  }
  
  bgSetting()
  {
    const bg = qs('.p-top-aboutus__bg')
    
    const val1 = isSP() ? -1500 : -1000
    const val2 = isSP() ? 1500 : 0
    
    const div = document.createElement("div")
    div.style.position = "absolute"
    div.style.top = 0
    div.style.left = 0
    div.style.height = "100%"
    this.el.parentNode.appendChild(div)
    
    
    
    gsap.fromTo(bg, 
      { y:val1 },
      {
        y:val2,
        duration: 1, 
        ease: "linear",
        
        scrollTrigger: {
          trigger : div,
          start   : "top bottom",
          end     : "bottom top",
          scrub   : true,
          // markers : true,
          // onUpdate:(self)=>{
          //   console.log(self.progress)
          // }
        }
    })
    
    
    const io = new IntersectionObserver( entries =>
    {
      entries.forEach( entry =>
      {
        if(entry.isIntersecting)
        {
          this.el.classList.add("is-inview")
        }
        else
        {
          this.el.classList.remove("is-inview")
        }
      })
    }, {
      rootMargin: '0% 0%',
      threshold: 0
    })

    io.observe(this.el)
  }
}
